import { http, HttpResponse } from 'msw';

import { debitCard1Mock } from '../data/debitCards';
import { resource } from '../helpers';

export const debitCardsHandler = [
    http.get(resource('/debit-cards'), async ({ request }) => {
        const searchParams = new URLSearchParams(request.url.split('?')[1]);
        const ownership = searchParams.get('ownership');
        if (ownership === 'OWN') {
            return HttpResponse.json([debitCard1Mock]);
        }
        return HttpResponse.json([]);
    }),
    http.get(resource('/debit-cards/:id'), async ({ params }) => {
        if (params.id === debitCard1Mock.id) {
            return HttpResponse.json(debitCard1Mock);
        }

        return HttpResponse.json(null);
    }),
];
